import { Link } from 'react-router-dom';
import type { TvShow } from '@/types/tv';
import ScoreBadge from '@/components/feature/ScoreBadge';

interface LatestListProps {
  shows: TvShow[];
}

export default function LatestList({ shows }: LatestListProps) {
  if (shows.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-foreground-500 bg-background-100 rounded-lg border border-background-200">
        暂无最新剧集
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {shows.map((show) => (
        <Link
          key={show.id}
          to={`/detail/${show.id}`}
          className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <div className="w-16 md:w-20 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
            <img
              src={show.poster}
              alt={`${show.title}海报`}
              title={`${show.title} - 最新更新高评分电视剧`}
              className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {show.title}
              </h3>
              <ScoreBadge score={show.score} />
            </div>
            <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500 flex-wrap">
              <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800">{show.region}</span>
              <span>{show.year}</span>
              <span className="w-1 h-1 rounded-full bg-background-400"></span>
              <span>{show.status}</span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-foreground-500 line-clamp-2">{show.intro}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}